import * as React from 'react';

function SvgSearchIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 19" {...props}>
      <circle
        cx={11.535}
        cy={7.379}
        r={4.218}
        stroke="#ff3E45"
        strokeWidth={2}
        transform="rotate(45 11.535 7.379)"
      />
      <path stroke="#ff3E45" strokeWidth={2} d="m8.27 10.72-4.541 4.54" />
    </svg>
  );
}
export default SvgSearchIcon;
